import { render, staticRenderFns } from "./EdAlert.vue?vue&type=template&id=3c1844b0&"
import script from "./EdAlert.vue?vue&type=script&lang=js&"
export * from "./EdAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports